<template>
    <div>
      <div
        ref="target"
        class="dx-tag-content"
      
      >
 
        <span>{{ tagData.title }}</span>
        
        <div
          
          class="dx-tag-remove-button"
        @click="removeItem"/>
      </div>
  

    </div>
  </template>
  <script setup lang="ts">
  import { ref } from 'vue';
  import { useCalcBuildingStore } from "../store/useCalcBuildingStore";
  const $buildingStore = useCalcBuildingStore();
  type TagData = Record<any, any>;
  
  const props = withDefaults(defineProps<{
    tagData?: TagData
  }>(), {
    tagData: () => ({} as TagData),
  });
  const removeItem =()=>{
//$buildingStore.removeItemFromBasket(props.tagData.guidItem)
//var a = 1
    if (props.tagData.article.type == 'walls' || props.tagData.article.type == 'roof') {
      $buildingStore.unicBasketArticles[props.tagData.article.type].params = {}
    }
    $buildingStore.removeItemFromBasket(props.tagData.guidItem)
  }
 
  const target = ref(null);
  </script>
  <style scoped>
  .dx-tag-content {
    display: flex;
    align-items: center;
  }
  
  .tag-img {
    height: 30px;
    margin-right: 5px;
  }
  
  .dx-tag-content.disabled-tag {
    padding-right: 6px;
    opacity: 0.5;
    cursor: not-allowed;
  }
  </style>
  